import React, { Fragment } from 'react';
import ccnyLogo from '../../assets/ccny-logo-reverse-clip.svg';
import msLogo from '../../assets/mediastorm-logo-reverse.svg';
import tfLogo from '../../assets/transformative-logo-reverse.svg';


const Footer = ({ links }) => (
  <footer className="page-group-footer">
    <div className="mb-4 d-flex flex-column flex-md-row align-items-center justify-content-md-between align-items-md-end">
      <a className="mb-3 mb-md-0" href="https://www.carnegie.org/">
        <img src={ccnyLogo} alt="New Agenda" width={250} />
      </a>
      <div className="page-group-footer-links">
        {(links || []).map(({ linkText, url }, idx) => (
          <Fragment key={idx}>
            <a href={url}>{linkText}</a>{idx + 1 < (links || []).length ? '|' : null}
          </Fragment>
        ))}
      </div>
    </div>
    <div className="d-flex flex-column flex-md-row align-items-center justify-content-md-between align-items-md-end">
      <div className="d-flex flex-wrap flex-column flex-md-row align-items-center mb-3 mb-md-0">
        <span className="mb-2 mb-md-0 pr-md-2">Produced&nbsp;by</span>
        <a href="https://mediastorm.com/"><img src={msLogo} alt="MediaStorm" width={150} className="mb-2 mb-md-0" /></a>
        <span className="d-none d-md-inline px-2">and</span>
        <a href="http://www.transformative.io/"><img src={tfLogo} alt="Transformative" width={200} /></a>
      </div>
      <div style={{ whiteSpace: 'nowrap' }}>
        &copy; Carnegie Corporation of New York, {new Date().getFullYear()}
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/PageGroup/Footer.js